
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq8f6as7ybHeThpBicV7BnzhAtAm38FWXg2KPkGZGIyDwMeta } from "/codebuild/output/src114802214/src/src/pages/faq.vue?macro=true";
import { default as menu5xC8aiXqsWRlchkv_SBU3sPfBY0ewIfntiZYYzRDbMsMeta } from "/codebuild/output/src114802214/src/src/pages/menu.vue?macro=true";
import { default as indexq6sovhS3GJdJ_o2jHCI_B8tP_45EhlidIsSvEtqIS_45ZvcMeta } from "/codebuild/output/src114802214/src/src/pages/index.vue?macro=true";
import { default as contactrkCKrvhr6S4knepY1bWg_plyDeHIqYb1d2kxlxlp7X8Meta } from "/codebuild/output/src114802214/src/src/pages/contact.vue?macro=true";
import { default as tutorialSSw5wNnSY60Yahf9NI_456ljDtgLyb1IS5uq97UFvPGKAMeta } from "/codebuild/output/src114802214/src/src/pages/tutorial.vue?macro=true";
import { default as agreement0J327NHdLnbm4S7_45b_45_aXC_45FI2Hfo2I54P2c3RITXEwMeta } from "/codebuild/output/src114802214/src/src/pages/agreement.vue?macro=true";
import { default as about_45pass6HRqsB88lxeQH8O0z_p6wrpJN6AStzqBnpXg8o5UEnIMeta } from "/codebuild/output/src114802214/src/src/pages/about-pass.vue?macro=true";
import { default as index9azuDOZVR982NsyjRjnWJqCYPMe60k_45uONb4HFmC6iQMeta } from "/codebuild/output/src114802214/src/src/pages/card/index.vue?macro=true";
import { default as _91id_933hEjr6ZtmeH4yFbMQLC84eVMqnflWvlYUlNH19ERJCAMeta } from "/codebuild/output/src114802214/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancekIDl6r4dwtBzbPqP0jA1UY0XqgXUPOWB1gs5h8bKkiwMeta } from "/codebuild/output/src114802214/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93p_45rE1ePQnpumt31AVGDOJ6FkI9siXZWMTIZwnUdgM_MMeta } from "/codebuild/output/src114802214/src/src/pages/notice/[id].vue?macro=true";
import { default as indexd1X0zZgt8uovhXS_ZEc8PcIz6MSXb9nH1QNMDOTG3FQMeta } from "/codebuild/output/src114802214/src/src/pages/coupon/index.vue?macro=true";
import { default as indexuyizOtAXo3364Flss6LsIpznonLAtQQqpK7INzJEDasMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/index.vue?macro=true";
import { default as indexGZfnaf2oPs9k03LkmrvwSw8yAGCsyWsBarJZu8eu9xEMeta } from "/codebuild/output/src114802214/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_9380z7R33_l8tdayLl1s4fWuX9u_455OdZ7hooulhzhqqKQMeta } from "/codebuild/output/src114802214/src/src/pages/parking/[id].vue?macro=true";
import { default as indexq32KZc_45pEO91rZHlTFXjFY80aWYs7wjqURFdWVIUNHYMeta } from "/codebuild/output/src114802214/src/src/pages/history/index.vue?macro=true";
import { default as indexE30QdDjhHeg4mGsxsSECzjhDeV032r8jznnASI97YakMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/index.vue?macro=true";
import { default as index6f2dqIJ2pPHO9rrwkodAiHfHxmefVxZ_r6d_MdQRAqQMeta } from "/codebuild/output/src114802214/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexVg9nzzBIfduOvdszU12eUfSjc_45kj3_zeWINiG2eT6koMeta } from "/codebuild/output/src114802214/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavizW491zLU76sPmSN26d5aRzVHsVecUq_45XVMNNg9qrFs8Meta } from "/codebuild/output/src114802214/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edittVWPcbGv7q7J_c297IjPFbIMwAMr3G74JQ5nShPFQKAMeta } from "/codebuild/output/src114802214/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementFRV8LcxLHHGbrxZlREQ7UEzP9idyDc6tVtVp1iBMzkAMeta } from "/codebuild/output/src114802214/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexLvbH5IB4tYHaGCGiik7WhnAqOGAc7uHPd9Oje1uvDfUMeta } from "/codebuild/output/src114802214/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dpbNEsmPVwlAl05JpIOsnBquqiG7KxFVT4NMVD3cE380Meta } from "/codebuild/output/src114802214/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmBXIJ1pEm4HwrKmS9Rbmv49MDcIWz9QJSIYs_45MW7kvUIMeta } from "/codebuild/output/src114802214/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexrhaboz_45WPRhQupizZeu9ymY942bdab_45qvrzBHr8XzO8Meta } from "/codebuild/output/src114802214/src/src/pages/card/create/index.vue?macro=true";
import { default as indexmKrNoUDjAj5EbrZDax4R6ALsRh8xlae9i8BKqjt2qYkMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmlruYHn2uwLyfaEKFbSYTDVENwrGkV_uscohHroYXZBMMeta } from "/codebuild/output/src114802214/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmXgkK5pC76oGPCrK2U54AiTQAxZNeHiBsDWa71z74bIoMeta } from "/codebuild/output/src114802214/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeObzdvcOWjPyox0_455lpvDk6a2R58nAiXWtaPByCGsGeMMeta } from "/codebuild/output/src114802214/src/src/pages/membership/complete.vue?macro=true";
import { default as registerciYvYSj2MJ26Uq0etb2k_45r5tLQp3BhZ4S0gESADh_45fUMeta } from "/codebuild/output/src114802214/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93K_CHmYAxO4xIUTPpRkOwmpQJ47aEN6voHjSuxl1YrBkMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmMvzC_45YvZ3lRZMI9lzIWt5MYSABYIFq_45elcnL8dLSjtUMeta } from "/codebuild/output/src114802214/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93_452Bx_45uVKYYzLg4rX_45yh_45S8uiLC1Vk5Ebv1MsFJhV_45M4Meta } from "/codebuild/output/src114802214/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexDgWEKIbOlw_45KDcDkl54K_45sUWazQYM_GLDEuRwj_45CzhMMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codebe_457gqY6lM1_zr7ipAL04iPNDmdECjd13szMqo3rKlUMeta } from "/codebuild/output/src114802214/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeXNXg5zvkYwEvDbepC0OtCSaOGjiHKC2Pi9l78vkptsUMeta } from "/codebuild/output/src114802214/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeQt5iq72xKZFSFilBvAyHlXy4xI0TRp3PcLxH5eCyX54Meta } from "/codebuild/output/src114802214/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register_o4HJGsgFTFJFkUI8K2LfTY7NK2z54KauRlNgdUoFpQMeta } from "/codebuild/output/src114802214/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeL5coMhsUeSrbmXy_n5rKvY29EqS2QrDH7sBXxfP96p0Meta } from "/codebuild/output/src114802214/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexsexBtbrm2nxrb2ePikYj70saj_y5Qya9NMKG29APXRUMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmNqECmsPVr5Dt0QhKwF1xuWVrqh16h9OoCGAn26aJBnUMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completebzsORD25neITuuA9DKtBzaY2sEkh4_453LMjgMcr4lN2UMeta } from "/codebuild/output/src114802214/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexy4d_I4hnl7qr2Dmtb8mYbVFOW1QS9zXz5LHUaXblGpoMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ZFUNwxH7TWyjf8VUM1fKA1cA5FdwXdpmF8guuWPgQGgMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeUcgaiRRPOt0_45vFv7ixeZ6nstGdvzs_453twKtd5m_457dXMMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasO8fYIq7R8oIyuU_45aeCP7dLkNtj40Ikr_45mN5Bx3ToRQsMeta } from "/codebuild/output/src114802214/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleXBfNNTOE5pRpfA6ZlkskSqgTs_45gNQIVN7y5e_45114qqUMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailD7T6OHgK2724GnmGcu5C5u_45e0SFnMTNqgjCuiFnTmkcMeta } from "/codebuild/output/src114802214/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmPsAI_45wDM3wTU3PPyHeSefoGZc4QC1KcnU0q2asVHVu0Meta } from "/codebuild/output/src114802214/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consenthtXq3Wq0Wk4dABdyUQv8BE7V6T9WocSa8DK_4529ghVUEMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmroVQzyLdWv_45CXkP0Ybo9rMtLJ381Gtabi9VUREXuY_sMeta } from "/codebuild/output/src114802214/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatevYGaQiC7ZL_45hRDv942Y9By9VyQfhTcolAGs_45VNKrZkAMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete_Xmif3Pvj3BaJrev7DslE7y5cgEW_Cqk9nb78GecStcMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeP63WbQ5TmFqgio1s6SvQpcdOigKhucPnl_fwXsEHqiQMeta } from "/codebuild/output/src114802214/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password9AsS98eV0gLIDIT7_454N_4551aj6gzwSO7DPwxsYutWis4Meta } from "/codebuild/output/src114802214/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliased_0N2QF0IoqRqYhxsaL_45dy6u1a_45_FmwTvf2H5K6ak0Meta } from "/codebuild/output/src114802214/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registersePBWK5EsCZl5Z8Y4EwzhHyLcn8Rsdf5PS3Fm_k5oCAMeta } from "/codebuild/output/src114802214/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code9XX_Dt5kHZygh53NmnLEpHX1lEl5AWpaA1Fkv1TyiPAMeta } from "/codebuild/output/src114802214/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexL0WuKoe8_nVTpSog_gN2h4ogpSl8VKa8Ea1kDTLERRwMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexhJaKRC_dJZTF3PLwHFgL3_45JGDkunRzQvm8uZmSiA_45jQMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexcyCZ7_4565a1DlfbjvfkN__kF_vrULk9YKgfSIMgWRaEQMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexUQt3cUpaI2ucV6_45wA9fDZ_cr8ygqVpl8LkbiEPIXF4kMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateX3XDUrv_DoDFBVIfHOd1ml6057jI6DfOt0XSo_45k1gmYMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeDDrsu_wt74fH3J9R49n_rrOL28B2cGepEfw1f3McfzYMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmiMdYRxXEE5pUhogJm4PCfA9BdCWMI2jaxYJfvM5iPoUMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexpHfcXhmpqBQf5oRpqtQp9jLon40vGtRoeUYdZ_RWH6IMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeCCZBBMIut2bIIX0rs96D_7nZCeTz_45YtiAI6hUMIvtrwMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateVTJevjlQuz667KBpnrLv0gqQYXUJYZz4FXNh0tldIokMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexYRSKYKFRX4EDVIkl4L1N_45YtFGPf3Cp9PVXY5g4jjWHEMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexh_45y_45o4GMTKYthIiv_45HGUwecyWZWnovjygNBvSgQwgFcMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeExme9_afjrpWoaVHSwC2OegWIWerPCRemCYBiaLFqegMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexqQHtNnRyZ1X6HYfne43SH8GazoUIgFh7OYGVt_45K5gQ0Meta } from "/codebuild/output/src114802214/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeOCjZd1w0_zXNVS5U2KKwcku0SiLpoCQYitRLJ8oHnFkMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexpMabo2bgnkDBmsOvktfslJkuyW_aZzXWUtEJFRMYPxkMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexg3lSEKRIxJ28pUiVWaegtJxn1IRX9ccmDzDY31E_45UDMMeta } from "/codebuild/output/src114802214/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexqLCl_45AREu0Zsnev7uL5ax8WRY0fvy47Bt2JiW3kV_45H0Meta } from "/codebuild/output/src114802214/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatebv6MNp4X1h_yt4fzlFkhV0I8tGVakJ2r_MraLkje0cQMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm1YIgu_yALPK5C2dZp_45ZlPgfle1DvouzOesNBZHlNCdUMeta } from "/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src114802214/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu5xC8aiXqsWRlchkv_SBU3sPfBY0ewIfntiZYYzRDbMsMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexq6sovhS3GJdJ_o2jHCI_B8tP_45EhlidIsSvEtqIS_45ZvcMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src114802214/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src114802214/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src114802214/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src114802214/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src114802214/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexd1X0zZgt8uovhXS_ZEc8PcIz6MSXb9nH1QNMDOTG3FQMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src114802214/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src114802214/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexq32KZc_45pEO91rZHlTFXjFY80aWYs7wjqURFdWVIUNHYMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index6f2dqIJ2pPHO9rrwkodAiHfHxmefVxZ_r6d_MdQRAqQMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexVg9nzzBIfduOvdszU12eUfSjc_45kj3_zeWINiG2eT6koMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src114802214/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src114802214/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexrhaboz_45WPRhQupizZeu9ymY942bdab_45qvrzBHr8XzO8Meta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmlruYHn2uwLyfaEKFbSYTDVENwrGkV_uscohHroYXZBMMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmXgkK5pC76oGPCrK2U54AiTQAxZNeHiBsDWa71z74bIoMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeObzdvcOWjPyox0_455lpvDk6a2R58nAiXWtaPByCGsGeMMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerciYvYSj2MJ26Uq0etb2k_45r5tLQp3BhZ4S0gESADh_45fUMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmMvzC_45YvZ3lRZMI9lzIWt5MYSABYIFq_45elcnL8dLSjtUMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codebe_457gqY6lM1_zr7ipAL04iPNDmdECjd13szMqo3rKlUMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeXNXg5zvkYwEvDbepC0OtCSaOGjiHKC2Pi9l78vkptsUMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeQt5iq72xKZFSFilBvAyHlXy4xI0TRp3PcLxH5eCyX54Meta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register_o4HJGsgFTFJFkUI8K2LfTY7NK2z54KauRlNgdUoFpQMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmNqECmsPVr5Dt0QhKwF1xuWVrqh16h9OoCGAn26aJBnUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completebzsORD25neITuuA9DKtBzaY2sEkh4_453LMjgMcr4lN2UMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexy4d_I4hnl7qr2Dmtb8mYbVFOW1QS9zXz5LHUaXblGpoMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeUcgaiRRPOt0_45vFv7ixeZ6nstGdvzs_453twKtd5m_457dXMMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleXBfNNTOE5pRpfA6ZlkskSqgTs_45gNQIVN7y5e_45114qqUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailD7T6OHgK2724GnmGcu5C5u_45e0SFnMTNqgjCuiFnTmkcMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmPsAI_45wDM3wTU3PPyHeSefoGZc4QC1KcnU0q2asVHVu0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consenthtXq3Wq0Wk4dABdyUQv8BE7V6T9WocSa8DK_4529ghVUEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmroVQzyLdWv_45CXkP0Ybo9rMtLJ381Gtabi9VUREXuY_sMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete_Xmif3Pvj3BaJrev7DslE7y5cgEW_Cqk9nb78GecStcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeP63WbQ5TmFqgio1s6SvQpcdOigKhucPnl_fwXsEHqiQMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password9AsS98eV0gLIDIT7_454N_4551aj6gzwSO7DPwxsYutWis4Meta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src114802214/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registersePBWK5EsCZl5Z8Y4EwzhHyLcn8Rsdf5PS3Fm_k5oCAMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code9XX_Dt5kHZygh53NmnLEpHX1lEl5AWpaA1Fkv1TyiPAMeta || {},
    component: () => import("/codebuild/output/src114802214/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src114802214/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src114802214/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]